import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"
import { spawnErrorToast } from "@hm/fundamental"
import { Customer, getCustomers, getPlants, Plant } from "@shared/api"
import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

type State = {
	plants?: Plant[]
	customers?: Customer[]
}

type Actions = {
	fetchPlantFilterData: (apiClient: APIClient) => Promise<void>
	fetchCustomerFilterData: (apiClient: APIClient) => Promise<void>
}

export const useFilterStore = create<State & Actions>()(
	immer(set => ({
		plants: undefined,
		customers: undefined,

		fetchPlantFilterData: async (apiClient: APIClient) => {
			try {
				const response = await getPlants(apiClient)

				set(state => {
					state.plants = response
				})
			} catch {
				spawnErrorToast("Failed to fetch plant filter data")
			}
		},
		fetchCustomerFilterData: async (apiClient: APIClient) => {
			try {
				const response = await getCustomers(apiClient)

				set(state => {
					state.customers = response.customers
				})
			} catch {
				spawnErrorToast("Failed to fetch customer filter data")
			}
		},
	})),
)
